"use strict";

const {
  isInArticle
} = document.currentScript.dataset;
function iframeWidgetInitialize(iframeWidget, type) {
  if (window.articleId) {
    const showIframeWidget = window.getSettingsFromApi(`${type}_widget_article`);
    const excludeArticleIDs = window.getSettingsFromApi(`${type}_widget_article_exclude_ids`);
    if (!showIframeWidget || type === 'admiral' && excludeArticleIDs.includes(window.articleId)) {
      console.warn(`[${type.toUpperCase()} Widget] Not initialized`);
      return;
    }
  }
  const iframeWidgetIframe = iframeWidget.querySelector('iframe');
  if (!iframeWidgetIframe) return;
  const iframeWidgetUrl = window.getSettingsFromApi(`${type}_widget_url`);
  const iframeUrl = type === 'admiral' ? iframeWidgetUrl || 'https://widget.admiral.hr/24sata/?admreferral=24sata&utm_source=24sata&utm_medium=widget&utm_campaign=actual' : iframeWidgetUrl;
  iframeWidgetIframe.src = iframeUrl;
  window.iFrameResize({
    checkOrigin: false
  }, iframeWidgetIframe);
  iframeWidget.style.display = 'block';
}
window.prepareWidget = widgetType => {
  const type = widgetType === 'lesnina' ? 'lesnina' : 'admiral';
  const iframeWidget = document.querySelector(`.js_${type}Widget`);
  if (!iframeWidget) return;
  if (window.apiSettings) {
    iframeWidgetInitialize(iframeWidget, type);
  } else {
    document.addEventListener('BaseDataLoaded', () => {
      iframeWidgetInitialize(iframeWidget, type);
    });
  }
};
if (isInArticle === 'true') {
  ['DOMContentLoaded', 'PremiumArticleContentLoaded'].forEach(event => {
    document.addEventListener(event, window.prepareWidget);
  });
} else {
  if (window.apiSettings) {
    window.prepareWidget();
  } else {
    document.addEventListener('FeedInitialized', () => {
      window.apiSettings ? window.prepareWidget() : document.addEventListener('BaseDataLoaded', window.prepareWidget);
    });
  }
}